import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WaterAttribute extends Sensor {
  public waterChart: any;
  private waterSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.waterChart = null;
    this.waterSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.waterSensor, position);
      this.waterSensor[position].push([timestamp, element.water]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWater = this.waterSensor.filter(series => series.length > 0);

    const positionNodeWater = this.waterSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterChart = this.getConfigChar(
      'water',
      this.getChartSeriesNewNode('Sensor', filteredWater, positionNodeWater),
      this.getRanges('water'),
      this.getLimits('water')
    );
  }

  public hasWaterSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterSensor.length &&
      this.waterSensor[index].length > 0
    );
  }

  public getWaterSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterSensor.length) {
      const sensorData = this.waterSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Precipitación', value: 'water' }
    ];
  }
}
